import { connect } from 'react-redux';
import {
  getSortColumn,
  getSortReversed,
  getPrecision,
  getCompare,
  getSortPage,
} from '../../selectors/options';
import {
  getTimespanIntervalWithData,
  getCrimeTypeText,
} from '../../selectors/crimes';
import {
  getLocationsTableSorted,
  getSelectedLocationsInPopulationSubset,
} from '../../selectors/locations';
import {
  selectLocations,
  setSorting,
  setSortPage,
} from '../../actions/options';
import { isCensusView } from '../../selectors/router';

import LocationTable from './LocationTable';

export default connect(
  state => ({
    censusView: isCensusView(state),
    precision: getPrecision(state),
    locations: getLocationsTableSorted(state),
    selectedLocationsIds: getSelectedLocationsInPopulationSubset(state),
    sortColumn: getSortColumn(state),
    sortReversed: getSortReversed(state),
    compare: getCompare(state),
    timespan: getTimespanIntervalWithData(state),
    sortPage: getSortPage(state),
    crimeType: getCrimeTypeText(state),
  }),
  {
    selectLocations,
    setSorting,
    setSortPage,
  },
)(LocationTable);



// WEBPACK FOOTER //
// ./src/components/LocationTable/LocationTableContainer.jsx